// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3ymWK","tab":"Tabs_tab__29e6L","tabActive":"Tabs_tabActive__36JKr"};